import { useEffect, useState } from 'react';
import { UserApi } from '../../../api';
import { PublicUserDto } from '../../../commonTypes/user.types';
import { useContainer } from '../../../hooks/useContainer';

const useHttpGetUsers = (organizationId: string) => {
    const userApi: UserApi = useContainer(UserApi);

    const [data, setData] = useState<PublicUserDto[]>([]);

    useEffect(() => {
        const { exec, abort } = userApi.getAllUsersFromOrganization({
            params: { organizationId },
            onSuccess: res => {
                setData(res.body);
            },
            onError: error => console.log(error),
        });

        if (organizationId) exec();
        return abort;
    }, [organizationId]);

    return { data, setData };
};

export default useHttpGetUsers;
